import type { Order, Payment } from "@graphql/generated/types";
import type { IAdyenPaymentMethodStrategy } from "@interfaces/payment-method/AdyenDefaultPaymentMethodStrategy";
import type { PaymentValues } from "@lib/utils/checkoutHelper";
import { getReadablePaymentMethod, getSuccessPayment, logError } from "./adyenPaymentMethodUtils";

export class AdyenAdvancedFlowStrategy implements IAdyenPaymentMethodStrategy {
    resolve(order: Order): PaymentValues {
        const payment = getSuccessPayment(order);

        if (!payment) {
            logError("PAYMENT: Advanced flow payment not found", order?.cart?.id);
            return {
                paymentSystem: null,
                paymentSystemIcon: null,
                paymentReference: null,
                paymentDateOfExpiry: null,
            };
        }

        const paymentSystem = this.getPaymentSystem(payment);

        return {
            paymentSystem: paymentSystem,
            paymentSystemIcon: null,
            paymentReference: null,
            paymentDateOfExpiry: null,
        };
    }

    private getMakePaymentResponse(payment: Payment) {
        const makePaymentResponse = payment?.custom?.customFieldsRaw?.find(
            (customField) => customField?.name === "makePaymentResponse"
        );
        return makePaymentResponse ? JSON.parse(makePaymentResponse?.value) : null;
    }

    private getPaymentSystem(payment: Payment): string | null {
        if (payment?.paymentMethodInfo?.method === "scheme") {
            const parsedMakePaymentResponse = this.getMakePaymentResponse(payment);
            return getReadablePaymentMethod(parsedMakePaymentResponse?.paymentMethod?.brand);
        }

        return payment?.paymentMethodInfo?.method
            ? getReadablePaymentMethod(payment?.paymentMethodInfo?.method)
            : null;
    }
}
